// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext.tsx';
import { CustomizationProvider } from './context/CustomizationContext.tsx';
import { ModulesProvider } from './context/ModulesContext.tsx';
import { installFetchInterceptor } from './utils/fetchInterceptor.ts';
import { clearNativeRefreshToken } from './utils/nativeTokenStore.ts';
import './index.css';

// Wraps window.fetch so a 401 from our backend transparently calls
// /refresh and retries once. Must run before any provider mounts so the
// very first /session call benefits from auto-refresh too.
installFetchInterceptor();

// Deletes a refresh token an older release stashed in the Keychain / Keystore (native only, no prompt).
clearNativeRefreshToken();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
        <CustomizationProvider>
          <ModulesProvider>
            <AuthProvider>
              <App/>
            </AuthProvider>
          </ModulesProvider>
        </CustomizationProvider>
    </BrowserRouter>
  </React.StrictMode>
);

